import { BaseService } from './BaseService';

export interface CategoryDropdownItem {
  value: string;
  label: string;
}

class CategoryService extends BaseService<CategoryDropdownItem> {
  constructor() {
    super('/api/Categories');
  }

  async getDropdownCategories(): Promise<CategoryDropdownItem[]> {
    try {
      return await this.get<CategoryDropdownItem[]>('/dropdown');
    } catch (error) {
      console.error('Error fetching categories dropdown:', error);
      throw error;
    }
  }
}

export const categoryService = new CategoryService();
